import React from "react";

import "./lingo3g-branding.css";

import { CarrotSearchText } from "@carrotsearch/ui/logo/CarrotSearchText.js";
import { Lingo3GLogo } from "@carrotsearch/ui/logo/Lingo3GLogo.js";
import { App } from "@carrotsearch/ui/AppContainer.js";
import { CarrotLogo } from "@carrotsearch/ui/logo/CarrotLogo.js";

const AExt = ({ href, children }) => {
  return (
    <a href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
};

const lingo3gBranding = {
  product: "Lingo3G",
  createProductName: () => <>Lingo3G</>,
  createAppLogo: () => <Lingo3GLogo />,
  createAppInfoNavLink: () => (
    <App
      icon={<CarrotLogo />}
      title="carrotsearch.com"
      path="https://carrotsearch.com"
    >
      <p>
        More information about the Lingo3G clustering engine, FoamTree and
        Circles visualizations. Free trials available.
      </p>
    </App>
  ),
  pageTitle: process.env.REACT_APP_META_TITLE,
  createSlogan: () => (
    <>
      This app uses Carrot Search{" "}
      <AExt href="https://carrotsearch.com/lingo3g">Lingo3G</AExt>{" "}
      to organize search results into clearly-labeled topics for instant
      overview and efficient research.
    </>
  ),
  createStartPageLogo: () => (
    <>
      <Lingo3GLogo />
      <CarrotSearchText title="Carrot Search" />
    </>
  ),
  createAboutIntro: () => (
    <div>
      <p>
        This is a demo application of the{" "}
        <AExt href="https://carrotsearch.com/lingo3g/">
          Lingo3G document clustering engine
        </AExt>
        . It uses Lingo3G to organize search results into thematic folders.
        Clustering is done in real time, based only on search results, without
        external knowledge bases.
      </p>
    </div>
  ),
  createAboutDetails: () => (
    <div>
      <h3>FAQ</h3>

      <dl>
        <dt>
          Does the use of Lingo3G clustering as part of this demo require a
          license fee?
        </dt>
        <dd>
          <p>
            No, you can use this Lingo3G demo free of charge. License fees are
            required when deploying Lingo3G on your own servers or workstations,
            either standalone or integrated with your application.
          </p>

          <p>
            Please note though that this demo imposes daily usage quotas to
            avoid abusive use of the free service. The quotas should not affect
            reasonable use of the application.
          </p>
        </dd>

        <dt>Is this application Open Source?</dt>
        <dd>
          <p>
            Yes, the source code of this demo application is available as part
            of the Carrot<sup>2</sup> framework under the Apache Software
            License 2.0. This means you can freely reuse this application, along
            with Carrot<sup>2</sup>
            clustering algorithms, for your open source or commercial projects.
          </p>

          <p>
            Please note, however, that the source code of parts of this
            application is not available. In particular, the Lingo3G clustering
            algorithm, FoamTree treemap and Circles pie-chart are proprietary
            commercial offerings and come only as binary distributions.
          </p>
        </dd>
      </dl>

      <h3>More information</h3>

      <ul>
        <li>
          For more details about the clustering engine, see{" "}
          <AExt href="https://carrotsearch.com/lingo3g/">
            Lingo3G document clustering engine website
          </AExt>
          .
        </li>

        <li>
          Source code of this application and several clustering algorithms is
          available in the{" "}
          <AExt href="https://github.com/carrot2/carrot2">
            Carrot<sup>2</sup> framework
          </AExt>
          .
        </li>

        <li>
          The treemap view uses the{" "}
          <AExt href="https://carrotsearch.com/foamtree/">
            Carrot Search FoamTree
          </AExt>{" "}
          visualization component.
        </li>

        <li>
          The pie-chart view uses{" "}
          <AExt href="https://carrotsearch.com/circles/">
            Carrot Search Circles
          </AExt>{" "}
          visualization component.
        </li>
      </ul>
    </div>
  ),
  createUnlimitedDistributionInfo: () => {
    return (
      <>
        <strong>Tip:</strong> If you have IT and programming skills, you can
        install this application on your own hardware. This will remove limits
        on the rate and size of clustering requests. Get in touch at
        <AExt href="mailto:info@carrotsearch.com">
          info@carrotsearch.com
        </AExt>{" "}
        for an evaluation package.
      </>
    );
  }
};

export const branding = lingo3gBranding;
